import { HistogramCanvasLayout } from './HistogramCanvasLayout.js';
import { HistogramChartGridLayout } from './HistogramChartGridLayout.js';
import { HistogramGridZeroLine } from './HistogramGridZeroLine.js';
import { HistogramChartOverlaysBorder } from '../overlays/HistogramOverlaysBorder.js';
import { ThresholdIndicators } from '../thresholds/ThresholdIndicators.js';

export const HistogramChartPlot = () => (
  <>
    <HistogramChartGridLayout />
    <ThresholdIndicators />
    <HistogramCanvasLayout />
    <HistogramGridZeroLine />
    <HistogramChartOverlaysBorder />
  </>
);

HistogramChartPlot['displayName'] = 'HistogramChartPlot';
